import React from 'react';
import styles from './styles/FarewellDiagnosis.module.css';
import LogoSmiofi from '../../../assets/images/diagnosticos/SymbolBetaLight.svg';
import LogoGrowtty from '../../../assets/images/Logo_Negro_Verde_3.webp';
export const FarewellDiagnosis = () => {
  return (
    <div className={styles.containerParentNode}>
      <div className={styles.containerFarewellDiagnosis}>
        <h2 className={styles.title}>
          ¡Tu inversión en el futuro digital comienza aquí!
        </h2>
        <div>
          <p>
            El informe detallado ha sido enviado a tu correo electrónico en
            formato PDF. Este diagnóstico profundo ofrece una comprensión clara
            de dónde se encuentra tu empresa en su trayectoria digital,
            destacando las áreas de oportunidad para una evolución
            significativa.
          </p>
          <p>
            Una vez que hayas tenido la oportunidad de revisar tu diagnóstico,
            te invitamos a conectarte con nosotros para hablar de los resultados
            y cómo podemos acompañarte en la implementación de estrategias de
            transformación digital a medida para tu negocio.
          </p>
        </div>
        <div className={styles.containerInformation}>
          <h3 className={styles.subtitle}>Más información en:</h3>
          <p className={styles.text}>
            <b>Sitio web:</b>&nbsp;
            <a className={styles.urlWebSites} href={'https://www.growtty.com'}>
              https://www.growtty.com
            </a>
          </p>
          <p className={styles.text}>
            <b>Instagram:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={'https://www.instagram.com/growttty/'}
            >
              https://www.instagram.com/growttty/
            </a>
          </p>
          <p className={styles.text}>
            <b>Facebook:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={'https://www.facebook.com/profile.php?id=61557376898016'}
            >
              https://www.facebook.com/profile.php?id=61557376898016
            </a>
          </p>
          <p className={styles.text}>
            <b>Linkedin:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={
                'https://www.linkedin.com/company/growtty-colombia/?viewAsMember=true'
              }
            >
              https://www.linkedin.com/company/growtty-colombia/?viewAsMember=true
            </a>
          </p>
        </div>
        <div className={styles.containerLogos}>
          <h3 className={styles.subtitle}>Desarrollado por:</h3>
          <p className={styles.textLogos}>
            Growtty&nbsp;{' '}
            <img
              className={styles.imgLogo}
              alt={'company-logo'}
              src={LogoGrowtty}
            />
            &nbsp;&nbsp;|&nbsp;&nbsp;Smiofi&nbsp;{' '}
            <img
              className={styles.imgLogo}
              alt={'company-logo'}
              src={LogoSmiofi}
            />
          </p>
        </div>
      </div>
    </div>
  );
};
